import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import { Input } from "@shared/ui/Inputs";
import { AssignItemListItem } from "@shared/ui/ListItemCards";
import AppModal from "@shared/ui/Modal";
import { Info } from "phosphor-react";
import React from "react";
import { useIntl } from "react-intl";
import { Waypoint } from "react-waypoint";

import { NotFoundComponent } from "./_notFoundMessage";
import { ITEMS_BEFORE_PAGE } from "../constants";
import { NoUserAssignedIcon } from "../icons/icons";

const AssignItemModal = ({
  handleSubmit,
  isOpen,
  handleClose,
  updateBtnText,
  disableUpdate,
  selectedItems,
  setSelectedItems,
  getFilteredItems,
  getThumbnail,
  getTitle,
  getId,
  headerText,
  infoMessage = "",
  searchQuery,
  setSearchQuery,
  itemsLoading = false,
  onScrollToBottom = () => {},
  loaderComponent = () => {},
  contentClassName = "",
  getVisibilityScope,
  getSubItemText,
}) => {
  const { messages } = useIntl();
  const [searchValue, setSearchValue] = React.useState("");

  const filteredItems = React.useMemo(
    () => getFilteredItems(searchValue) ?? [],

    [getFilteredItems, searchValue],
  );

  const handleRowClick = (event, id) => {
    event.stopPropagation();
    const index = selectedItems.findIndex((item) => item === id);
    if (index >= 0) {
      setSelectedItems((prev) => {
        const newIds = [...prev];
        newIds.splice(index, 1);

        return newIds;
      });
    } else {
      setSelectedItems((prev) => [...prev, id]);
    }
  };

  return (
    <AppModal
      className="assign-item-modal min-h-[500px]"
      contentClassName={`flex-1 ${contentClassName}`}
      handleSubmit={handleSubmit}
      isOpen={isOpen}
      handleClose={handleClose}
      updateButtonText={updateBtnText}
      disableUpdate={disableUpdate}
      disableCancel={false}
      title={headerText}
      content={
        <div className="flex flex-col h-full">
          <div className="w-full pb-lg">
            <Input
              onChange={(e) => {
                setSearchValue(e.target.value);
                setSearchQuery(e.target.value);
              }}
              placeholder={
                messages?.productionLines?.assignMachineToProductionLineModal
                  .serachMachinePlaceHolder
              }
              value={searchQuery ?? searchValue}
            />
          </div>

          {infoMessage && filteredItems.length > 0 && (
            <div className="assign-item-modal-info-container flex items-center gap-sm w-full p-sm mb-md">
              <Info size={16} />
              <BodyText size={BODY_TEXT_SIZES.X_SMALL} className="flex-1">
                {infoMessage}
              </BodyText>
            </div>
          )}

          <div className="flex-1 overflow-hidden">
            {itemsLoading && !filteredItems.length ? (
              loaderComponent()
            ) : filteredItems.length > 0 ? (
              <div className="overflow-auto max-h-[380px] pr-xs">
                {filteredItems.map((item, index) => {
                  const name = getTitle(item);
                  const itemId = getId(item);
                  const thumbnail = getThumbnail(item);
                  return (
                    <React.Fragment key={index + "-assign-item"}>
                      <div onClick={(e) => handleRowClick(e, item._id)}>
                        <AssignItemListItem
                          isChecked={selectedItems.includes(item._id)}
                          name={name}
                          itemId={itemId}
                          thumbnail={thumbnail ? getThumbnail(item) : null}
                          visibilityScope={
                            typeof getVisibilityScope === "function"
                              ? getVisibilityScope(item)
                              : undefined
                          }
                          subItemText={
                            typeof getSubItemText === "function"
                              ? getSubItemText(item)
                              : undefined
                          }
                        />
                      </div>
                      {!itemsLoading &&
                      index === filteredItems.length - ITEMS_BEFORE_PAGE ? (
                        <Waypoint onEnter={onScrollToBottom} />
                      ) : null}
                    </React.Fragment>
                  );
                })}
                {itemsLoading ? loaderComponent() : null}
              </div>
            ) : (
              <NotFoundComponent icon={<NoUserAssignedIcon />} />
            )}
          </div>
        </div>
      }
    />
  );
};

export default AssignItemModal;
